import AuthModule from './auth.module'
import CustomerTypeModule from './customerType.module'
import EmailModule from './email.module'
import LineOfficialAccountModule from './lineOfficialAccount.module'
import OrderModule from './order.module'
import ProductModule from './product.module'
import UserModule from './user.module'
import PaymentModule from './payment.module'
import FeedbackModule from './feedback.module'
import SystemConfigModule from './systemConfig.module'
import CookieConsentModule from './cookieConsent.module'
import QRCodePopupModule from './qrcodePopup.module'
import FileModule from './file.module'
import TaxAgentModule from './taxAgent.module'

export default {
  Auth: AuthModule,
  Email: EmailModule,
  LineOfficialAccount: LineOfficialAccountModule,
  CustomerType: CustomerTypeModule,
  Order: OrderModule,
  Product: ProductModule,
  User: UserModule,
  Payment: PaymentModule,
  Feedback: FeedbackModule,
  SystemConfig: SystemConfigModule,
  CookieConsent: CookieConsentModule,
  QRCodePopup: QRCodePopupModule,
  File: FileModule,
  TaxAgent: TaxAgentModule
}
